import { Component, ChangeDetectorRef } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { NavigationEnd, NavigationStart, Router } from '@angular/router'
import { first, skipWhile } from 'rxjs'
import { UserService } from './shared/services/user.service'
import { TourGuideService } from './shared/services/tour-guide.service'
import * as Sentry from '@sentry/angular'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  user
  showTourGuide = false

  constructor(
    private userService: UserService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    public cdr: ChangeDetectorRef,
    private tourGuideService: TourGuideService,
    router: Router,
    trace: Sentry.TraceService
  ) {
    this.userService?.localAuthSetup()
    this.userService?.handleAuthCallback()
    this.registerIcons()

    this.userService?.dkeUser$
      .pipe(
        skipWhile((user) => user == null),
        first()
      )
      .subscribe(
        (user) => {
          this.user = user
          this.cdr.detectChanges()
        },
        (err) => {}
      )
  }

  private registerIcons() {
    this.matIconRegistry?.addSvgIcon(
      'overtur',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/Overtur.svg')
    )
    this.matIconRegistry?.addSvgIcon(
      'lock',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/Lock.svg')
    )
    this.matIconRegistry?.addSvgIcon('key', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/Key.svg'))
    this.matIconRegistry?.addSvgIcon(
      'user',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/User.svg')
    )
    this.matIconRegistry?.addSvgIcon(
      'help',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/Help.svg')
    )
    this.matIconRegistry?.addSvgIcon(
      'information',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/Information.svg')
    )
    this.matIconRegistry?.addSvgIcon(
      'pencil',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/Pencil.svg')
    )
  }
}
